<template>
  <div class="empresas">
    <banner-interno
    :banner="'bg_topo.jpg'"
    :imagem="page.image"
    :titulo="'Empresas'"
    />
    <div class="container empresas__info">
      <div class="row">
        <menu-sobre />
        <div class="col-12 col-md-9">
          <div class="empresas__list">
            <ul>
              <li class="w-100" v-for="(item,index) in partners" :key="index">
                <a v-if="item.link" :href="item.link" target="_blank">
                  <div class="empresas__list__box">
                    <div class="row align-items-center">
                      <div class="col-lg-3 col-md-4 col-12">
                        <div class="empresas__list__box__logo text-center" v-if="item.image">
                          <img :src="item.image" :alt="item.title">
                        </div>
                      </div>
                      <div class="col-lg-9 col-md-8 col-12">
                        <h2 class="ui-subtitle ui-subtitle--uppercase">
                          {{item.title}}
                        </h2>
                        <div class="ui-description ui-description--italic lh-30">
                          <p>
                            {{item.description}}
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>
                </a>
                <div v-if="!item.link" class="empresas__list__box">
                  <div class="row align-items-center">
                    <div class="col-lg-3 col-md-4 col-12">
                      <div class="empresas__list__box__logo text-center" v-if="item.image">
                        <img :src="item.image" :alt="item.title">
                      </div>
                    </div>
                    <div class="col-lg-9 col-md-8 col-12">
                      <h2 class="ui-subtitle ui-subtitle--uppercase">
                        {{item.title}}
                      </h2>
                      <div class="ui-description ui-description--italic lh-36">
                        <p v-html="item.description"></p>
                      </div>
                    </div>
                  </div>
                </div>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import BannerInterno from './BannerInterno'
import MenuSobre from './MenuSobre'
import CtaConheca from './CtaConheca'
import { mapGetters } from 'vuex'

export default {
  components: {
    BannerInterno,
    MenuSobre,
    CtaConheca
  },
  computed: {
    ...mapGetters([
      'page',
      'partners'
    ])
  },
  created () {
    this.$store.dispatch('showPage', 6)
    this.$store.dispatch('loadPartners')
  }
}
</script>
<style lang="scss" scoped>
@import '../assets/scss/_variables.scss';
.empresas {
  background: $bgIntern;
  &__info{
    margin-top: 21.5em;
    @media (max-width: 1024px) {
      margin-top: 14em;
    }
    @media (max-width: 800px) {
      margin-top: 11em;
    }
    @media (max-width: 500px) {
      margin-top: 6em;
    }
    &__dados{
      p{
        margin-top: 12px;
      }
    }
  }
  &__list {
    li {
      margin-bottom: 30px;
    }
    &__box {
      background: white;
      border-radius: 10px;
      box-shadow: 20px 20px 35px 0px rgba(0, 26, 66, 0.2);
      padding: 70px 50px;
    }
    @media (max-width: 1200px) {
      &__box {
        padding: 30px;
      }
    }
    @media (max-width: 991px) {
      &__box {
        padding: 15px;
      }
    }
    @media (max-width: 767px) {
      &__box {
        &__logo {
          margin-bottom: 20px;
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Empresas.vue